import React, { useState } from 'react';
import { User } from '../../../../graphql/graphql';
import UserAvatarImage from '../../../../Components/UserAvatar/UserAvatarImage';
// @ts-ignore
import styles from './PatientProfileEditableImage.module.scss';
import PatientProfileImageEditModal from './PatientProfileImageEditModal';

interface Props {
	user: User;
	className?: string;
	onProfileImageChange?: () => void;
}

const PatientProfileEditableImage: React.FC<Props> = ({
	user,
	className,
	onProfileImageChange,
}) => {
	const [isEditOpen, setIsEditOpen] = useState(false);

	const onChange = () => {
		setIsEditOpen(false);
		onProfileImageChange?.();
	};

	return (
		<>
			<div className={styles.wrapper} onClick={() => setIsEditOpen(true)}>
				<UserAvatarImage
					userId={user.id}
					customClass={className}
					isDoctor={false}
					createdAt={user.avatarFile?.createdAt}
					profileImageUrl={user.profileImageUrl}
				/>
				<div className={styles.edit} />
			</div>
			{isEditOpen && (
				<PatientProfileImageEditModal
					isOpen={isEditOpen}
					patientId={user.id}
					onClose={() => setIsEditOpen(false)}
					onSuccess={onChange}
				/>
			)}
		</>
	);
};

export default PatientProfileEditableImage;
